class SiteElementFilterSingleInputRenderer
    extends QueryElement<HTMLElement> 
    implements ISiteElementFilterRenderer {


    private readonly _input: QueryElement<HTMLElement>;
    private readonly _filter: SiteElementFilterSingle;
    
    private _timer?: number;

    constructor(filter: SiteElementFilterSingle, value: ISiteFilterItem) {
        super(document.createElement("DIV"));
        this._filter = filter;

        this.addClass("element-filter-input");
        
        var container = QueryElement.QueryElement("DIV")
            .addClass("container")

        this._input = QueryElement.QueryElement("INPUT")
            .setAttr("type", "text")
            .setAttr("name", "Search")
            .setAttr("title", "Search");
        
        this._input.setVal(filter.getValue());
        
        this._input.on("keyup", () => {
            if (this._timer != null)
                window.clearTimeout(this._timer);
            
            this._timer = window.setTimeout(() => this.setValue(), 500);
        });
        
        container.append(this._input);
        this.append(container);
    }

    setValue() {
        this._filter.setValue(this._input.getVal() || "");
        this._filter.updateFilterModel(false);
    }
    giveFocus() {
        var element = this._input.get() as HTMLInputElement;
        element.selectionStart = 1000;
        element.selectionEnd = 1000;
        element.focus();
    }

    getState() {
        return null;
    }
}